import { transformAutoFill } from './autofill.transformers'
import { transformConcatenation } from './concat.transformers'
import { transformConstant } from './constant.transformers'
import { transformDate } from './date.transformers'
import { transformLink } from './link.transformers'
import { transformList } from './list.transformers'
import { transformText } from './text.transformers'

const NOOP = valueObj => valueObj.cell_value

const TRANSFORMERS = {
  text: transformText,
  autofill: transformAutoFill,
  constant: transformConstant,
  list: transformList,
  concatenation: transformConcatenation,
  link: transformLink,
  date: transformDate,
}

export function getValueTransformer(templateField = {}, options = {}) {
  // if transformers are disabled, we just return the original value
  if (options.disableTransformers && !options.runReadOnlyTransformers) {
    return NOOP
  }

  const governanceOwner =
    templateField.field && templateField.field.segment_type === 'variable'
      ? templateField
      : templateField.field || {}

  let governanceType = governanceOwner.governance_type
  if (governanceType === 'link' && templateField.autofill) {
    governanceType = 'autofill'
  }
  const transformer = TRANSFORMERS[governanceType] || NOOP
  return transformer
}
